@if (isNew()) {
    @if (newBPOptions().length != 0) {
        <div class="row normal-row">
            <meta-select-button 
            [availableMetas]="this.newBPOptions()"
            [alreadySelected]="this.alreadySelectedFN()"
            (onSelect)="onNew($event)"
            [labelCbObs]="this.labelFn()" />
        </div>                
    }
} @else if (this.onlyContents()) {
    @let sc = this.components();
    <div class="row normal-row clickable" [class.parent-bck]="!this.showFocus" [class.key-select]="this.showFocus" (click)="open()">{{meta()?.no}}:{{sc?.index | tkdata:'bijzprgm':{'default': meta()?.omschr?.toString()} | async }}</div>
    @for (param of sc?.params; track $index) {
        <div class="row normal-row clickable" [class.parent-bck]="!this.showFocus" [class.key-select]="this.showFocus" (click)="open()">{{param}}</div>
    }
} @else {
<div class="row normal-row clickable" [class.parent-bck]="!this.showFocus" [class.key-select]="this.showFocus" (click)="open()">
    <span class="desc" [title]="meta()?.index">{{meta()?.no}}:{{meta()?.index | tkdata:'bijzprgm':{'default': meta()?.omschr?.toString()} | async }}</span>
    @let sc = this.components();
    <span class="params">
        @if (!this.onlyDesc()) {
            
            @for (param of sc?.params; track $index) {
                <span class="param">{{param}}</span>
            }
        }
    </span>
</div>
}
<kendo-dialog *ngIf="isEditing" title="Edit Extra Programma: {{meta()?.index | tkdata:'bijzprgm':{'default': meta()?.omschr?.toString()} | async }}" 
        width="600px"  (close)="this.close()" autoFocusedElement="input">
    <div>
        @for (paramMeta of paramsMeta(); track paramMeta.pmeta.no) {
        <fieldset :class="cell" *ngIf="this.editValue.params[paramMeta.pmeta.no] != undefined">
            <legend :class="legend">{{meta()?.index+'.'+(paramMeta.pmeta.no+1) | tkdata:'bijzprgmparam':{'default': paramMeta.pmeta.omschr.toString()} | async }} - {{servoKCTypeLabel(editValue.params[paramMeta.pmeta.no]) }}</legend>
            @let type = this.kanaalService.getKCParamType(editValue.params[paramMeta.pmeta.no]);
            @if (type != undefined) {
                @let rType = {ioType: type.ioType, range: type.range, start: type.start, inverted: editValue.params[paramMeta.pmeta.no].inverted};
                <kanaal-input [initialValue]="rType" [assignement]="paramMeta.assign" 
                    (valueChanged)="this.onParamKanaalChange($event, paramMeta.pmeta.no)" [autofilKanaal]="false"></kanaal-input>    
            } @else {
                <kendo-numerictextbox [(value)]="editValue.params[paramMeta.pmeta.no].waarde" format="n0" 
                [style]="{ width: '100px' }"></kendo-numerictextbox>
            }

        </fieldset>
        }
        <div>{{meta()?.functieText}}</div>
    </div>
    <kendo-dialog-actions>
        <button kendoButton (click)="this.close()">Cancel</button>
        <button kendoButton (click)="onDelete()" themeColor="primary" *ngIf="!isNew()">
            Delete
        </button>
        <button kendoButton (click)="onSave()" themeColor="primary">
            Save
        </button>
    </kendo-dialog-actions>
</kendo-dialog>
